import React from "react";
import { Navigate } from "react-router-dom";

const GuestGuard = ({ children }) => {
  const isAuthenticated = localStorage.getItem("authToken") !== null;

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default GuestGuard;
